import Swiper from "swiper";

export class TimelineTabsSlider {
    constructor() {
        new Swiper('.timeline-day-btns', {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: false,
            on: {
                init: (swiper) => {
                    let currentTab = $('.b-mobile-timeline .timeline-day-btns .btn-timeline-day.active');
                    if (currentTab.length > 0) {
                        swiper.slideTo(+currentTab.data('slide-id'))
                    }
                }
            },
            breakpoints: {
                992: {
                    spaceBetween: 18,
                }
            }
        });
    }
}
